import React, { useEffect, useState } from "react";
import EmaButton from "components/emaButton/EmaButton";
import { useTranslation } from "react-i18next";
import UserDetailWrapper from "./UserDetailWrapper";
import { getElements, putElement } from "services/apiEndpoints/Endpoints";
import Loading from "components/loading/Loading";
import UserPermission from "./UserPermission";
const UserDetails = ({ getUsers, setUserDetails, user }) => {
  const [userData, setUserData] = useState(null);
  const [formErrors, setFormErrors] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [loading, setLoading] = useState(Loading);
  const { t } = useTranslation();

  const dispatchUser = (action) => {
    setUserData((prev) => {
      if (action.type === "permission") {
        return {
          ...prev,
          permission: { ...prev.permission, ...action.payload },
        };
      } else {
        return { ...prev, [action.type]: action.value };
      }
    });
  };
  //PUT ELEMENT
  const put = () => {
    putElement(`/Admin/User/${user.userId}`, userData).then((response) => {
      if (response.success) {
        getUsers();
        setUserDetails(false);
      } else if (response.vErrors) {
        setFormErrors(response.vErrors);
      }
    });
  };
  // GET USER
  //PUT ELEMENT
  const getUser = () => {
    setLoading(Loading);
    getElements(`/Admin/User/${user.userId}`).then((res) => {
      setUserData({
        userId: res.data.userId,
        givenName: res.data.givenName,
        email: res.data.email,
        familyName: res.data.familyName,
        phone: res.data.phoneNumber,
        fullName: res.data.fullName,
        permission: res.data.permission,
      });
      setLoading(false);
    });
  };

  useEffect(getUser, []);

  return (
    <div className="slider-panel">
      <div className="slider-header d-block">
        <div>
          <div className="d-flex justify-content-between">
            <section className="slider-header-title">
              {userData?.fullName}
            </section>
            <section className="slider-header-buttons">
              <EmaButton
                title={t("Cancel")}
                onClick={() => setUserDetails(false)}
              />
              <EmaButton title={t("Save")} btnDark onClick={put} />
            </section>
          </div>
          {/* START Tabs */}
          <div className="custom-tabs-content">
            <section
              className={`custom-tab-item ${
                selectedTab == 1 ? "selected-custom-tab" : ""
              }`}
              onClick={() => setSelectedTab(1)}
            >
              Details
            </section>
            <section
              className={`custom-tab-item ${
                selectedTab == 2 ? "selected-custom-tab" : ""
              }`}
              onClick={() => setSelectedTab(2)}
            >
              Permissions
            </section>
          </div>
          {/* END */}
        </div>
      </div>
      <div className="slider-body">
        {selectedTab === 1 ? (
          <>
            {loading ? (
              loading
            ) : (
              <>
                <UserDetailWrapper
                  state={userData}
                  dispatchUser={dispatchUser}
                  errors={formErrors}
                />
              </>
            )}
          </>
        ) : (
          <>
            {loading ? (
              loading
            ) : (
              <>
                <UserPermission state={userData} dispatchUser={dispatchUser} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default UserDetails;
